<template>
    <section>
      <div class="w-full bg-white rounded-md mt-2 p-4">
        <div class="w-full flex gap-2 items-center">
          <i class="pi pi-list"></i>
          <p class="text-lg font-bold">Listado de Localizaciones</p>
          <Button @click="displayModalLocalicaion = true, idLoc = null" class="ml-auto rounded-md" label="Crear Localización" />
        </div>
        <div class="grid grid-cold-1 md:grid-cols-2 lg:grid-cols-5 gap-2 my-2">
          <!-- filtro por Municipio -->
          <div class="w-full">
            <label class="text-xs text-gray-600" for="mun">Municipio</label>
            <InputText class="w-full" id="mun" @keyup.enter="listarLocalizaciones" v-model="filtros.nomMpio" />
          </div>
          <!-- filtro por Departamento -->
          <div class="w-full">
            <label class="text-xs text-gray-600" for="dep">Departamento</label>
            <InputText class="w-full" id="dep" v-model="filtros.nomDpto"/>
          </div>
          <div class="flex gap-2">
            <Button @click="listarLocalizaciones" class="mt-5 mb-1.5 rounded-md" label="Buscar" />
            <Button @click="limpiarFiltros" class="mt-5 mb-1.5 rounded-md p-button-outlined p-button-secondary" label="Limpiar" />
          </div>
        </div>
        <div class="w-full my-2">
          <DataTable class="p-datatable-sm text-xs" :value="localizaciones.rows" responsiveLayout="scroll">
            <Column header="Codigo">
              <template #body="{data}">
                <div class="text-center pt-3">
                  <p>{{ data.id }}</p>
                  <div class="flex gap-x-4 hover:text-blue-600 text-white transition ease-in-out duration-500">
                    <button class="underline italic" @click='EditLoc(data.id)'>Editar</button>
                  </div>
                </div>
              </template>
            </Column>
            <Column field="codMpio" header="Cod Mun"></Column>
            <Column field="nomMpio" header="Municipio"></Column>
            <Column field="codDpto" header="Cod Dep"></Column>
            <Column field="nomDpto" header="Departamento"></Column>

            <Column header="acción">
              <template #body="{data}">
                <div class="p-2 rounded-md text-center" >
                  <Button
                      @click='DeleteLoc(data.id)'
                      severity="danger"
                      v-tooltip="'Inactivar'"
                      class='p-button-rounded p-button-icon-only mx-2'
                  >
                    <i class="pi pi-trash text-white"></i>
                  </Button>
                </div>
              </template>
            </Column>
          </DataTable>
          <Paginator v-model:first="offset"
            :rows="limit"
            :totalRecords="parseInt(localizaciones.count)"
            :rowsPerPageOptions="[2,10,20,30,100]"
            @page="onPage($event)"
          />
        </div>
      </div>
      <Dialog header="Crear Localización " v-model:visible="displayModalLocalicaion" :breakpoints="{'960px': '95vw'}" :style="{width: '60vw'}" :modal="true">
        <div class="grid gap-4 bg-white dark:bg-dark-1 dark:text-gray-500 w-full sm:grid-cols-2 lg:grid-cols-5 xl:grid-cols-5 xxl:grid-cols-5">
          <div class="sm:col-span-2 lg:col-span-5 xl:col-span-5 xxl:col-span-5">
            <crearLocalizacion @crearLoc="displayModalLocalicaion = false, listarLocalizaciones()" :idLoc="idLoc" />
          </div>
        </div>
      </Dialog>
      <Toast />
    </section>
</template>
<script setup>
  import { useToast } from 'primevue/usetoast'
  import Swal from 'sweetalert2'
  import LocalizacionService from '../../../../../services/localizacion.service'
  import { onMounted, ref, computed } from 'vue'
  import crearLocalizacion from './crear.vue'
    // name: 'ListadoOrdenesVenta'
    // Servicios
    const toast = useToast()
    const _LocalizacionService = ref(new LocalizacionService())
    // Referencias
    const localizaciones = ref([])
    const LocSeleccionada = ref()
    const limit = ref(10)
    const offset = ref(0)
    const filtros = ref({
      nomMpio: null,
      nomDpto: null
    })
    const idLoc = ref(null)
    const displayModalLocalicaion = ref(false)
    const params = computed(() => {
      return {
        limit: limit.value,
        offset: offset.value,
        ...filtros.value
      }
    })
    // Metodos
    const onPage = ({ first, page, pageCount, rows }) => {
      limit.value = rows
      listarLocalizaciones(params.value)
    }
    const listarLocalizaciones = () => {
      const object = {
        ...params.value,
        limit: limit.value,
        offset: offset.value
      }
      _LocalizacionService.value.paginate(object).then(({ data }) => {
        localizaciones.value = data
      })
    }
    const EditLoc = (id) => {
      displayModalLocalicaion.value = true
      idLoc.value = id
    }
    const DeleteLoc = (id) => {
      Swal.fire({
          title: 'Esta seguro de inactivar esta localización?',
          showDenyButton: true,
          denyButtonText: 'Cancelar',
          confirmButtonText: 'Inactivar'
        }).then((result) => {
          if (result.isConfirmed) {
            _LocalizacionService.value.inactivarLoc(id).then(({ data }) => {
              if (data.error) {
                console.error('Error al inactivar la localización, por favor intente nuevamente')
              } else {
                toast.add({ severity: 'success', summary: 'Exito', detail: 'localización inactivada exitosamente', life: 3000 })
              }
              listarLocalizaciones()
            })
          } else if (result.isDenied) {
            Swal.fire('Localizacion no eliminada', '', 'info')
          }
        })
    }
    const limpiarFiltros = () => {
      filtros.value = {
        nomMpio: null,
        nomDpto: null
      }
      LocSeleccionada.value = ''
      listarLocalizaciones()
    }
    onMounted(() => {
      listarLocalizaciones()
    })
</script>
<style>
  .p-dropdown-label{
    font-size: 0.75rem !important
  }
  .tipoId .p-dropdown-trigger {
    display: none !important;
  }
  ::-webkit-scrollbar-thumb {
    background: rgb(189, 189, 189);
    border-radius: 9999px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  ::-webkit-input-placeholder { /* Edge */
    color: gray;
  }
  ::-webkit-scrollbar {
    width: 0.4rem;
  }
</style>
